/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Discontinued = 'Website.Product.WebsaleAvailability.Discontinued';
export const OnlineOnly = 'Website.Product.WebsaleAvailability.OnlineOnly';
export const SoldOutOnline = 'Website.Product.WebsaleAvailability.SoldOutOnline';
